import {Component, EventEmitter, Input, Output} from '@angular/core';
import {VatDto} from '../../../../../Models/Core/vat.interface';

@Component({
  selector: 'app-amount-block',
  templateUrl: './amount-block.component.html',
  styleUrls: ['./amount-block.component.scss'],
  standalone: false
})
export class AmountBlockComponent {
  @Input() alternativeTaxes: number = 0;
  @Input() minimum: number = 0;
  @Input() subtotal: number = 0;
  @Input() total: number = 0;

  @Input() vats: VatDto[] = [];

  @Input() alertPrice!: boolean;
  @Input() alertIVA!: boolean;

  @Input() hasFreight: boolean = false;
  @Input() canEditFreight: boolean = false;

  @Input() freightIVA: number = 0;
  @Output() clickFreightIVA: EventEmitter<void> = new EventEmitter<void>();

  @Input() freight: number = 0;
  @Output() freightChange: EventEmitter<number> = new EventEmitter<number>();

  @Input() hasDiscount: boolean = false;
  @Input() canEditDiscount: boolean = false;

  @Input() discount: number = 0;
  @Output() discountChange: EventEmitter<number> = new EventEmitter<number>();

  @Input() discountAbs: number = 0;
  @Output() discountAbsChange: EventEmitter<number> = new EventEmitter<number>();

  @Output() saveAmountData: EventEmitter<void> = new EventEmitter<void>();

  isDiscountByAmount: boolean = false;

  /**
   * Alterna entre editar el descuento por porcentaje o por importe
   *
   */
  toggleDiscountType() {
    this.isDiscountByAmount = !this.isDiscountByAmount;
  }

}
